import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;

const navItems = [
  ['/', 'Home'],
  ['/programs', 'Programs'],
  ['/about', 'About'],
  ['/get-involved', 'Get Involved']
];

const logoUrl = 'https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/00698ec216769b881372e89204858926.png';

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <Link
        className="brand"
        to="/"
        onClick={() => setOpen(false)}
        aria-label="Legacy of Immortals home"
      >
        <img src={logoUrl} alt="Legacy of Immortals" />
      </Link>

      <button
        className="menu-button"
        onClick={() => setOpen(!open)}
        aria-label="Toggle navigation"
      >
        <SafeIcon icon={open ? FiX : FiMenu} />
      </button>

      <nav className={open ? 'main-nav is-open' : 'main-nav'} aria-label="Main navigation">
        {navItems.map(([path, label]) => (
          <NavLink
            key={path}
            to={path}
            onClick={() => setOpen(false)}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            {label}
          </NavLink>
        ))}
        <Link className="nav-cta" to="/get-involved" onClick={() => setOpen(false)}>
          Support the mission <SafeIcon icon={FiArrowUpRight} />
        </Link>
      </nav>
    </header>
  );
}

export default Header;